import React, { FC, useEffect, useState } from 'react';
import Skillbuilder from '../Skillbuilder';
import Header from '../ContentList/header';
import contentfulClient from '../../models/Contentful';
import { PageLoader } from '../../HOC/Page/WithPage';

const InternshipPrep: FC<any> = () => {
  const [skillbuilders, setSkillbuilders] = useState<any>();
  const [header, setHeader] = useState<any>();
  const skillbuilderInternship = async () => {
    const response = await contentfulClient.getEntries({
      content_type: 'skillbuilder',
      'fields.specialType': 'Internship Prep',
      order: ['-fields.launchedDate'],
    });
    return response;
  };
  const headerInternship = async () => {
    const response = await contentfulClient.getEntries({
      content_type: 'header',
      'fields.friendlyName': 'Internship Prep',
      limit: 1,
    });
    return response.items[0];
  };
  useEffect(() => {
    const getContentful = async () => {
      const skillbuilders = await skillbuilderInternship();
      const header = await headerInternship();
      setSkillbuilders(skillbuilders);
      setHeader(header);
    };
    getContentful();
  }, []);
  if (header && skillbuilders) {
    return (
      <>
        <h1 className="m-4 has-text-centered">{header.fields.heading}</h1>
        <Header title={header.fields.title} description={header.fields.description} />
        <div>
          {skillbuilders.items.map((item: any) => {
            item.fields.internship = true;
            return <Skillbuilder {...item} internship />;
          })}
        </div>
      </>
    );
  }
  return <PageLoader />;
};

export default InternshipPrep;
